import * as React from "react"

export const InfoTriggerTargetContext = React.createContext(null)
export const InfoTriggerPortalContext = React.createContext(false)
